<script setup>
import { ref, inject } from "vue";
import { __ } from '@/utils';
import Modal from "@components/modal.vue";
import Accordion from "@components/Accordion.vue";
import AccordionItem from "@components/AccordionItem.vue";
import IconAndroid from "../../icons/icon-android.vue";
import IconApple from "../../icons/icon-apple.vue";
import Copy from '@components/copy.vue'

const { selectedNumber, setProcessStep } = inject('activationProcess');
const isActive = ref(false);
</script>
<template>
    <div class="qr-section">
        <div class="step-heading side-spacing mb24">
            <h3 class="mb15"><strong>{{ __('The QR number is ready, now scan the code') }}</strong></h3>
            <button class="btn-circle-icon" type="button" @click="setProcessStep(1)">
                <span>{{ __('return') }}</span>
                <i class="ico ico--arrow-right"></i>
            </button>
            <p>{{ __('Please note that this code is linked') }} <strong class="red-text">{{ __('only to the number') }} {{ selectedNumber?.number }}</strong></p>
        </div>
        
        <div class="qr-code">
            <img src="https://placehold.co/227x227?text=QRcode" alt="">
        </div>
        <p class="fz19">
            <strong>{{ __('Before scanning the barcode, it is recommended to read.') }}</strong>
            <button type="button" class="btn btn--inline" @click="isActive = true">
                {{ __('instructions') }}
            </button>
            <br />
            <strong>{{ __('To install an eSIM, depending on the type of your device') }}</strong>
        </p>

    </div>

    <Accordion class="fz20">
        <AccordionItem class="alt" title="If code cannot be scanned - QR manial activation" :index="0">
            <div class="content-box">
                <p>
                    <strong>{{ __('iOS Users') }}</strong>
                </p>
                <p>
                    {{ __('Go to device settings > Cellular > Add eSIM (cellular terminal)') }}<br />
                    {{ __('Copy the activation code you received and enter it into two fields') }}
                </p>
                <p>
                    <span class="blue-text dib">{{ __('Address + DP-SM:') }}</span> SM-V4-052-A-GTM.PR.GO-ESIM.COM <Copy text="SM-V4-052-A-GTM.PR.GO-ESIM.COM" />
                </p>
                <p>
                    <span class="blue-text dib">{{ __('Activation Code:') }}</span> 2DC377F37FF8765CNY99312781 <Copy text="2DC377F37FF8765CNY99312781" />
                </p>
            </div>
            <div class="content-box">
                <p>
                    <strong>{{ __('Android Users') }}</strong>
                </p>
                <p>
                    {{ __('Go to Device settings > Connections > SIM card manager > Add mobile plan Copy the activation code you received into the activation code field') }}
                </p>
                <p>
                    <span class="blue-text dib">{{ __('Activation Code:') }}</span>  SM-V4-052-A-PR.GO-ESIM65CNY993127 <Copy text=" SM-V4-052-A-PR.GO-ESIM65CNY993127" />
                </p>
            </div>
        </AccordionItem>
    </Accordion>

    <Modal class="larger" :isActive="isActive" @close="isActive = false">
        <template #head>
            <h3>{{ __('Device type and Operatimg System - eSIM Installation') }}</h3>
        </template>
        <template #body>
            <p class="fz20 mb50">
                {{ __('Before activating eSIM, you must enter the device settings and follow') }}<br />
                {{ __('The instructions, depending on the operating system of the device') }}
            </p>
            <div class="grid-columns">
                <div class="grid-columns__item">
                    <div class="grid-columns__icon">
                        <div class="grid-columns__icon-image">
                            <IconApple />
                        </div>
                        <div class="grid-columns__icon-text">
                            <p>{{ __('eSIM Activation') }}</p>
                            <p>{{ __('IOS Operation system') }}</p>
                        </div>
                    </div>
                    <ol>
                        <li>{{ __('In the device settings, go to "Connections" > "SIM card manager" > "Add mobile package", then select "Scan service provider\'s QR code"') }}</li>
                        <li>{{ __('Scan the QR code and confirm with the relevant button') }}</li>
                    </ol>
                </div>
                <div class="grid-columns__item">
                    <div class="grid-columns__icon">
                        <div class="grid-columns__icon-image">
                            <IconAndroid />
                        </div>
                        <div class="grid-columns__icon-text">
                            <p>{{ __('eSIM Activation') }}</p>
                            <p>{{ __('Android Operation system') }}</p>
                        </div>
                    </div>
                    <ol>
                        <li>{{ __('In device settings, go to Cellular.') }}</li>
                        <li>{{ __('Click Add Mobile plan button and scan the QR code.') }}</li>
                        <li>
                            {{ __('In the following screens, the mode must be defined') }}
                            <ul>
                                <li>{{ __('label for cellular plans') }}</li>
                                <li>{{ __('Default line for issuing calls from the contact list on the device') }}</li>
                                <li>{{ __('Setting up a line for use with IMESSAGE u-FACETIME') }}</li>
                                <li>{{ __('Setting a default line to use cellular data') }}</li>
                            </ul>
                        </li>
                    </ol>
                    
                </div>
            </div>
        </template>
        <template #foot>
            <button class="btn w170" type="button" @click="isActive = false">
                {{ __('Close') }}
            </button><!-- /.btn -->
        </template>
    </Modal>
</template>